export default __webpack_public_path__ + "static/media/green top hat.2af6cad5.png";